import * as React from "react"
import styles from "./EmptyStateIndicator.module.scss"

import { EmptyStateIndicatorProps } from "stream-chat-react"
import { ReactComponent as StreamChatEmptyState } from "@assets/svg/stream-chat-empty-state-136x136.svg"

import AppText from "@components/general/AppText/AppText.tsx"

const EmptyStateIndicator: React.FC<EmptyStateIndicatorProps> = () => {
	return (
		<div className={`${styles.empty_state_indicator} `}>
			<StreamChatEmptyState />

			<main>
				<AppText className={styles.message} textKey="hello" />

				<AppText
					className={styles.message}
					textKey="how_can_we_help_you"
				/>
			</main>
		</div>
	)
}

export default React.memo(EmptyStateIndicator)
